// @todo: mover mensagens para arquivo
// @todo: adicionar testes unitários
export default {
  email: require('./validateEmail').default,
  phone: require('./validatePhone').default,
  field: require('./validateField').default,
  select: require('./validateSelect').default,
  options: require('./validateOptions').default,
};
